import { BreadcrumbsUI } from "./BreadcrumbsUI";
import { StandardProps } from "../componentMap";

export const Breadcrumbs = ({
  product,
  runtimeConfig,
  configProps,
}: Pick<StandardProps, "product" | "runtimeConfig" | "configProps">) => {
  const { aliases } = product;
  const beautySimplification = configProps?.beautySimplification === true;

  const { pimProductId: productId } = aliases;

  const { esiBasepath } = runtimeConfig;

  const breadcrumbPath = `${esiBasepath}/esi/breadcrumbs/product/${productId}`;

  return (
    <BreadcrumbsUI
      breadcrumbPath={breadcrumbPath}
      beautySimplification={beautySimplification}
    />
  );
};
